import { RemoteDataSource } from 'app/components/data/DataSource/Remote/RemoteDataSource'
import { debounce } from 'app/components/data/utils'

/**
 * RemotePagingDataSource
 */
export class RemotePagingDataSource<T extends object> extends RemoteDataSource<T> {

  private getRecordsDebounce = debounce<T[]>(() =>
    this.fetch<T[]>(this.config.transport.paging.read)
  )

  private getInitDebounce = debounce<number>(() =>
    this.fetch<number>(this.config.transport.paging.count)
  )

  protected getCount(): Promise<number> {
    return this.getInitDebounce()
  }

  protected getRecords(): Promise<T[]> {
    return this.getRecordsDebounce()
  }
}



// WEBPACK FOOTER //
// ./src/app/components/data/DataSource/Remote/Paging/index.ts